export default __webpack_public_path__ + "static/media/WAS0333.34I-41687_-24976_0.89c24294.jpg";